import { render, staticRenderFns } from "./AdvertisementTile.vue?vue&type=template&id=5777fcc9&"
import script from "./AdvertisementTile.vue?vue&type=script&lang=js&"
export * from "./AdvertisementTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports